<template>
  <v-row no-gutters>
    <v-col
      class="mb-2 ml-1 text-body-1"
      cols="12"
    >
      {{ label }}
    </v-col>
    <v-col
      class="mr-1"
    >
      <validation-provider
        v-slot="{ errors }"
      >
        <number-input
          v-model="minutes"
          outlined
          dense
          suffix="min"
          :placeholder="$t('label.e_g') + ' ' + 5"
          :decimal-precision="0"
          :error-messages="errors"
        />
      </validation-provider>
    </v-col>
    <v-col
      class="ml-1"
    >
      <validation-provider
        v-slot="{ errors }"
      >
        <number-input
          v-model="seconds"
          outlined
          dense
          suffix="s"
          :placeholder="$t('label.e_g') + ' ' + 30"
          :decimal-precision="0"
          :error-messages="errors"
        />
      </validation-provider>
    </v-col>
  </v-row>
</template>

<script>
  import NumberInput from '@/components/helpers/NumberInput.vue'

  export default {
    name: 'MinuteSecondInput',
    components: { NumberInput },
    props: {
      value: {
        type: [Number, String],
        default: null
      },
      label: {
        type: String,
        required: true
      },
      variable: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        minutes: this.value ? Math.floor(this.value / 60) : null,
        seconds: this.value ? this.value % 60 : null
      }
    },
    watch: {
      minutes: function (val, oldVal) {
        this.$emit('input', val, this.seconds, this.variable)
      },
      seconds: function (val, oldVal) {
        this.$emit('input', this.minutes, val, this.variable)
      }
    }
  }
</script>

<style scoped>

</style>
